import { LOGO_URL } from '@/pages/landing/components/data';

export { LOGO_URL };

export interface SaudeNavLink {
  label: string;
  href: string;
}

export const SAUDE_NAV_LINKS: SaudeNavLink[] = [
  { label: 'Soluções', href: '#solucoes' },
  { label: 'Crédito rastreável', href: '#credito' },
  { label: 'Canais e corretores', href: '#canais' },
  { label: 'Ranking e metas', href: '#ranking' },
  { label: 'Regras e integração', href: '#regras' },
  { label: 'Resultados', href: '#resultados' },
];

export const SAUDE_HERO_BG =
  'https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20cream%20gradient%20background%20representing%20a%20connected%20healthcare%20ecosystem%20with%20soft%20glowing%20network%20nodes%20and%20subtle%20medical%20cross%20symbols%20flowing%20organically%20into%20a%20horizon%2C%20premium%20technology%20aesthetic%2C%20clean%20minimal%20composition%2C%20warm%20orange%20golden%20tones%2C%20no%20text%2C%20high%20detail&width=1920&height=1080&seq=gp-saude-hero-01&orientation=landscape';

export const SAUDE_BENEFICIARIOS_IMG =
  'https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20diverse%20healthcare%20beneficiaries%20smiling%20while%20using%20a%20smartphone%20app%20to%20track%20wellness%20goals%20and%20rewards%2C%20bright%20modern%20clinical%20environment%20with%20soft%20natural%20window%20light%2C%20cream%20and%20amber%20tones%2C%20shallow%20depth%20of%20field%2C%20clean%20minimal%20composition%2C%20high%20detail&width=900&height=700&seq=gp-saude-beneficiarios-02&orientation=landscape';

export const SAUDE_ROI_IMG =
  'https://readdy.ai/api/search-image?query=Professional%20business%20analytics%20dashboard%20on%20a%20modern%20laptop%20screen%20showing%20upward%20growth%20charts%20and%20return%20on%20investment%20metrics%20in%20warm%20orange%20and%20amber%20tones%2C%20clean%20bright%20office%20desk%20with%20soft%20natural%20light%2C%20top%20down%20editorial%20photography%2C%20high%20detail&width=900&height=700&seq=gp-saude-roi-03&orientation=landscape';

export interface SocialLink {
  label: string;
  href: string;
  icon: string;
}

export const SOCIAL_LINKS: SocialLink[] = [
  { label: 'LinkedIn da GetPoints', href: 'https://www.linkedin.com', icon: 'ri-linkedin-fill' },
  { label: 'Instagram da GetPoints', href: 'https://www.instagram.com', icon: 'ri-instagram-line' },
  { label: 'YouTube da GetPoints', href: 'https://www.youtube.com', icon: 'ri-youtube-fill' },
];